export const sharedEnvironmentSys = {
  production: false,
  name: 'Systemtest',
  bgcolor: 'yellow',
  fontcolor: 'black',
  showEnvironment: true,
  cookieDomain: '.vinnova.se',

  //Endpoints
  portalAdminUrl: 'https://e-admin.sys.vinnova.se/adminportal',
  nJobEngineUrl: 'https://e-admin.sys.vinnova.se/njobengine',
  notifyServiceApiUrl: 'https://notifiering.api.sys.vinnova.se',
  eadminUrl: 'https://e-admin.sys.vinnova.se',
  sprakHanteringApiUrl: 'https://sprakresurser.api.sys.vinnova.se/api',
  bedomarpoolAdminUrl: 'https://bedomarpooladmin.sys.vinnova.se',
  oregApiUrl: 'https://organisationsregistret.api.sys.vinnova.se/api',
  bpoolApiUrl: 'https://bedomarpooladmin.api.sys.vinnova.se',
  effektaUrl: 'https://effekta.sys.vinnova.se',
  formBuilderApiUrl: 'https://formularbyggare.api.sys.vinnova.se',
  formBuilderUrl: 'https://formularbyggare.sys.vinnova.se',
  formAdmin: 'https://formularadmin.api.sys.vinnova.se',
  etjansterCommonApiUrl: 'https://etjanster.api.sys.vinnova.se',
  etjansterCommonUrl: 'https://etjanster.sys.vinnova.se',
  bpUrl: 'https://bedomningsportal.sys.vinnova.se',
  bpApiUrl: 'https://bedomningsportal.sys.vinnova.se/api',
  enkatRegisterUrl: 'https://projekt.sys.vinnova.se/enkatregister',
  oregUrl: 'https://projekt.sys.vinnova.se/oreg',
  healthMonitorApiUrl: 'https://monitorering.api.sys.vinnova.se',
  ansokanApiUrl: 'https://ansok.api.sys.vinnova.se',
  ansokanUrl: 'https://ansok.sys.vinnova.se',
  forhandsgranskaApiUrl: 'https://forhandsgranska.api.sys.vinnova.se/api',
  forhandsgranskaUrl: 'https://forhandsgranska.sys.vinnova.se',
  utlysningsbyggareApiUrl: 'https://utlysningsbyggare.api.sys.vinnova.se/api',
  utlysningsbyggareUrl: 'https://utlysningsbyggare.sys.vinnova.se',
  projektUrl: 'https://projekt.sys.vinnova.se',
  logServiceApiUrl: 'https://loggservice.api.sys.vinnova.se',
  gatewayUrl: 'https://test.api.vinnova.se/sys',
  signeringApiUrl: 'https://signering.api.sys.vinnova.se/api',

  apimSubscriptionKey: 'd35368d15dbb47c5a1bf6c93290fef15',

  // Keys
  tinyMceApiKey: '3v8orrp96m8v7vwbg61c31rrhu3dffg5wi6rlluihkl56ot0',

  //ClientIds
  azureAd: {
    formBuilderClientId: '056d9781-54a0-48de-b4b2-0ab7b4195366',
    formBuilderApiClientId: 'deb3816a-34f5-4971-8bcd-8fbe04ef7082',
    formAdminApiClientId: '8c8a3931-41f0-4600-a5f9-6f66e8f6e9e5',
    etjansterCommonApiClientId: '1ee0c953-8a37-4cca-a9e5-9341779a4a49',
    etjansterCommonApiScope: 'api://1ee0c953-8a37-4cca-a9e5-9341779a4a49/all',
  },
  azureAdB2C: {
    tenant: 'vinnovab2csys',
    authority:
      'https://vinnovab2csys.b2clogin.com/vinnovab2csys.onmicrosoft.com/',
    policies: {
      signUp: {
        name: 'B2C_1A_signup',
        authority:
          'https://vinnovab2csys.b2clogin.com/vinnovab2csys.onmicrosoft.com/b2c_1A_signup',
      },
      sso: {
        name: 'B2C_1_signupsignin_sso',
        authority:
          'https://vinnovab2csys.b2clogin.com/vinnovab2csys.onmicrosoft.com/b2c_1_signupandsignin_sso',
      },
      signInPhone: {
        name: 'B2C_1A_signin_phone',
        authority:
          'https://vinnovab2csys.b2clogin.com/vinnovab2csys.onmicrosoft.com/b2c_1A_signin_phone',
      },
      profileEdit: {
        name: 'B2C_1_profileedit',
        authority:
          'https://vinnovab2csys.b2clogin.com/vinnovab2csys.onmicrosoft.com/b2c_1_profileedit',
      },
      passwordChange: {
        name: 'B2C_1A_profile_edit_password_change',
        authority:
          'https://vinnovab2csys.b2clogin.com/vinnovab2csys.onmicrosoft.com/b2c_1a_profile_edit_password_change',
      },
      changeSignInName: {
        name: 'B2C_1A_changesigninname',
        authority:
          'https://vinnovab2csys.b2clogin.com/vinnovab2csys.onmicrosoft.com/b2c_1a_changesigninname',
      },
      signIn: {
        name: 'B2C_1A_signin',
        authority:
          'https://vinnovab2csys.b2clogin.com/vinnovab2csys.onmicrosoft.com/b2c_1A_signin',
      },
    },
    clientId: {
      etjansterCommonClientId: 'eb9c116c-bc38-4d05-9eac-6dffd800cc33',
      etjansterCommonApiClientId: '4bf86909-19c7-482f-8136-c6249a054201',
      ansokanClientId: '191800de-79dd-405e-b668-565851059a02',
      ansokanApiClientId: '001330ca-5880-4e8a-83c6-618f23f9a48d',
      bedomningsportalClientId: '7d4e7aa3-0d37-429c-b995-81dfa23d99c8',
      bedomningsportalApiClientId: 'bda4a6dd-317f-40bb-b251-2de123065812',
      projektClientId: '805580a4-12b2-4b4b-b59b-6ef08cb30a4e',
      projektApiClientId: '2f70d54a-2052-4bb6-9558-7a7b0e06b0d7',
      forhandsgranskaClientId: '66fbd544-27f7-4232-bd82-a278dc75a639',
      forhandsgranskaApiClientId: 'e6f6b3d5-a899-41c8-ace5-659322243953',
      enkatregisterApiClientId: '5a7b2918-71ba-434b-b4b0-9e371254a8aa',
      oregApiClientId: 'f76a233f-7415-4cc2-b391-123803447fb4',
      signeraApiClientId: '91dc9d11-8bcb-44e5-9615-8b973205f730',
    },
  },
  //Externa länkar
  externalLinks: {
    ansokanGuide: {
      sv: 'https://www.vinnova.se/sok-finansiering/sa-har-fyller-du-i-ansokan/',
      en: 'https://www.vinnova.se/en/apply-for-funding/how-to-complete-your-application/',
    },
    regler: {
      sv: 'https://www.vinnova.se/sok-finansiering/regler-for-finansiering/',
      en: 'https://www.vinnova.se/en/apply-for-funding/rules-for-our-funding/',
    },
    gdpr: {
      sv: 'https://www.vinnova.se/om-oss/vart-uppdrag/regler-som-styr-var-verksamhet/personuppgifter/',
      en: 'https://www.vinnova.se/en/about-us/our-mission/rules-that-govern-our-activities/how-we-handle-personal-data/',
    },
  },
  ga4MeasurementId: 'G-DJPY2PMYE7',
};
